import { render, staticRenderFns } from "./updatebarcodesHIstory.vue?vue&type=template&id=386b0cfe&scoped=true&"
import script from "./updatebarcodesHIstory.vue?vue&type=script&lang=js&"
export * from "./updatebarcodesHIstory.vue?vue&type=script&lang=js&"
import style0 from "./updatebarcodesHIstory.vue?vue&type=style&index=0&id=386b0cfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b0cfe",
  null
  
)

export default component.exports